var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ColumnEditModal",
    _vm._b(
      {
        attrs: {
          value: _vm.value,
          configName: _vm.configName,
          columnId: _vm.columnId,
          editMode: _vm.editMode,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "edit-modal-additions",
            fn: function (props) {
              return [
                _c(
                  "v-layout",
                  { attrs: { "pa-4": "", wrap: "" } },
                  [
                    _c("h3", [
                      _vm._v(" Creating new Mediatypes during Import "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getShouldCreateNewMediatypeValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.callSetColumnMetadata(
                              _vm.shouldCreateNewMediatypeKey,
                              !_vm.getShouldCreateNewMediatypeValue(
                                props.columnConfiguration
                              )
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          attrs: {
                            label:
                              "Allow Mediatypes to be created in Envirodata when a new Mediatype does not exist during an import",
                            value: true,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          attrs: {
                            label:
                              "Do not allow Mediatypes to be created and mark the import as unsuccessful when a new Mediatype does not exist during an import",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(" Delete empty Mediatypes during Rollback "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getShouldDeleteDuringRollbackValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.callSetColumnMetadata(
                              _vm.shouldDeleteDuringRollbackKey,
                              !_vm.getShouldDeleteDuringRollbackValue(
                                props.columnConfiguration
                              )
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          attrs: {
                            label:
                              "Delete Mediatypes that have no data associated with them during a rollback",
                            value: true,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          attrs: {
                            label:
                              "Do not delete Mediatypes and mark the rollback as unsuccessful when attempting to delete a Mediatype",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      },
      "ColumnEditModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }